module.exports = {
  en: {
    'HRES6JUC1': {
      '0': '[HRES6JU] Approve Training Request',
      '10': '[HRES6JU] Approve Training Request',
      '20': 'No.',
      '30': 'Emp. ID.',
      '40': 'Name',
      '50': 'Class',
      '60': 'Reqest Date',
      '65': 'No.',
      '70': 'Training Course',
      '80': 'Type of training',
      '90': 'Status',
      '100': 'Approved By',
      '110': 'Appr.Date',
      '120': 'Remark',
      '130': 'Next Approve',
      '140': 'Detail of Training Request',
      '150': 'Approve By Next Step'
    },
    'HRES6JUC2': {
      '0': 'Detail of Approve',
      '10': 'for Employee',
      '20': 'Seq.NO.',
      '30': 'Approved by',
      '40': 'Date',
      '50': 'Type Of Training',
      '60': 'Training Course',
      '70': 'Tr. Program',
      '80': 'Training Date',
      '90': 'To',
      '98': 'Assign',
      '99': 'Request for Training',
      '100': 'Month',
      '110': 'Year',
      '120': 'Institute Code',
      '130': 'Venue',
      '140': 'Expense',
      '150': 'Current Status',
      '160': 'Status',
      '170': 'Approved',
      '180': 'Refused',
      '190': 'Remark',
      '200': 'Training Schedule',
      '210': 'Class',
      '220': 'Start Date',
      '230': 'End Date'
    },
    'HRES6JUC3': {
      '0': 'Training Schedule',
      '10': 'Training Schedule',
      '20': 'Course',
      '30': 'Year',
      '40': 'Class',
      '50': 'Start Date',
      '60': 'End Date',
      '70': 'Time',
      '80': 'Venue',
      '90': 'Remark'
    },
    'HRES6JUC4': {
      '0': 'History of Trainning',
      '10': 'History of Trainning',
      '20': 'Emp. Code',
      '30': 'Year',
      '40': 'Code',
      '50': 'Course Name',
      '60': 'Type Of Training',
      '70': 'Class',
      '80': 'Expense',
      '90': 'Score',
      '100': 'Result',
      '110': 'Improvment after Training'
    },
    'HRES6JUC5': {
      '0': 'Details of Training Request',
      '10': 'Details of Request',
      '20': 'Employee Name',
      '30': 'Requested Date',
      '35': 'Course Name',
      '40': 'Training Course',
      '50': 'Class No.',
      '60': 'Category',
      '70': 'Training date',
      '75': 'Institute Code',
      '80': 'Venue',
      '90': 'Cost Per Head',
      '100': 'Remarks',
      '110': 'Update By',
      '120': 'Date Training',
      '130': 'To',
      '140': 'Attach File'
    },
    'HRESH6XC1': {
      '10': 'For Employee',
      '20': 'Type Of Training',
      '30': 'History of Training',
      '40': 'Year',
      '50': 'Month',
      '60': 'Class No.',
      '70': 'Course',
      '80': 'Course Name',
      '90': 'Type of',
      '100': 'Training',
      '110': 'Institute',
      '120': 'Instructor Name',
      '130': 'Trainnig Date',
      '140': 'Start Date',
      '150': 'End Date',
      '160': 'Training Hrs.',
      '170': '(Bath/Man)',
      '180': 'Training Hrs.'
    },
    'HRESH6XC2': {
      '10': 'Scholarship Receiving',
      '20': 'Code',
      '30': 'Scholarship Name',
      '40': 'Start Date',
      '50': 'End Date',
      '60': 'Com.',
      '70': 'Expire Date',
      '80': 'Scholarship',
      '90': 'Period (Mth)',
      '100': 'Expense'
    },
    'HRTR53C1': {
      '10': 'For Year',
      '20': 'For Month',
      '30': 'Tr. Program No.',
      '40': 'Or Course Code',
      '50': 'Course',
      '60': 'Course Name',
      '70': 'Month',
      '80': 'Class No.',
      '90': 'Start',
      '100': 'End',
      '110': 'Instructor / Institute',
      '120': 'Venue',
      '130': 'Not Specify',
      '140': 'Training Schedule',
      '150': 'Type Of Training'
    }
  },
  th: {
    'HRES6JUC1': {
      '0': '[HRES6JU] อนุมัติคำร้องการฝึกอบรม',
      '10': '[HRES6JU] อนุมัติคำร้องการฝึกอบรม',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'รุ่นที่',
      '60': 'วันที่ขอ',
      '65': 'ลำดับที่',
      '70': 'หลักสูตรอบรม',
      '80': 'ประเภท',
      '90': 'สถานะ',
      '100': 'ผู้อนุมัติ',
      '110': 'วันที่อนุมัติ',
      '120': 'หมายเหตุการอนุมัติ',
      '130': 'ผู้อนุมัติลำดับถัดไป',
      '140': 'คำร้องเรื่อง ขอฝึกอบรม',
      '150': 'อนุมัติโดยข้ามขั้นตอน'
    },
    'HRES6JUC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่',
      '50': 'ประเภท',
      '60': 'หลักสูตรอบรม',
      '70': 'รหัสโครงการ',
      '80': 'วันที่จัดอบรม',
      '90': 'ถึง',
      '98': 'Assign',
      '99': 'คำร้องเรื่อง การขอฝึกอบรม',
      '100': 'เดือน',
      '110': 'ปี',
      '120': 'สถาบันที่จัด/จัดโดย',
      '130': 'สถานที่จัดอบรม',
      '140': 'ค่าใช้จ่าย',
      '150': 'สถานะปัจจุบัน',
      '160': 'สถานะ',
      '170': 'อนุมัติ',
      '180': 'ไม่อนุมัติ',
      '190': 'หมายเหตุ',
      '200': 'ตารางการฝึกอบรม',
      '210': 'รุ่นที่',
      '220': 'วันที่เริ่มต้น',
      '230': 'วันที่สิ้นสุด'
    },
    'HRES6JUC3': {
      '0': 'ตารางการฝึกอบรม',
      '10': 'ตารางการฝึกอบรม',
      '20': 'หลักสูตร',
      '30': 'ปี',
      '40': 'รุ่นที่',
      '50': 'วันที่เริ่มต้น',
      '60': 'วันที่สิ้นสุด',
      '70': 'เวลา',
      '80': 'สถานที่',
      '90': 'หมายเหตุ'
    },
    'HRES6JUC4': {
      '0': 'ประวัติการฝึกอบรม',
      '10': 'ประวัติการฝึกอบรม',
      '20': 'รหัสพนักงาน',
      '30': 'ปี',
      '40': 'รหัส',
      '50': 'ชื่อหลักสูตร',
      '60': 'ประเภท',
      '70': 'รุ่นที่',
      '80': 'ค่าใช้จ่าย',
      '90': 'คะแนนที่ได้',
      '100': 'ผล',
      '110': 'ผลหลังการฝึกอบรม'
    },
    'HRES6JUC5': {
      '0': 'รายละเอียดคำร้องขอฝึกอบรม',
      '10': 'รายละเอียดคำร้องขอฝึกอบรม',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่ยื่นขอ',
      '35': 'ชื่อหลักสูตร',
      '40': 'หลักสูตรอบรม',
      '50': 'รุ่นที่',
      '60': 'ประเภท',
      '70': 'วันที่อบรม',
      '75': 'สถาบันที่จัด/จัดโดย',
      '80': 'สถานที่',
      '90': 'ค่าใช้จ่าย/คน',
      '100': 'หมายเหตุ',
      '110': 'ผู้บันทึก',
      '120': 'วันที่เข้าอบรม ตั้งแต่',
      '130': 'ถึง',
      '140': 'Attach File'
    },
    'HRESH6XC1': {
      '10': 'สำหรับพนักงาน',
      '20': 'ประเภทการอบรม',
      '30': 'ประวัติการเข้าอบรมของพนักงาน',
      '40': 'ปี',
      '50': 'เดือน',
      '60': 'รุ่นที่',
      '70': 'รหัสหลักสูตร',
      '80': 'ชื่อหลักสูตร',
      '90': 'ชนิด',
      '100': 'อบรม',
      '110': 'สถาบัน',
      '120': 'ชื่อวิทยากร',
      '130': 'วันที่อบรม',
      '140': 'วันที่เริ่มต้น',
      '150': 'วันที่สิ้นสุด',
      '160': 'ชม.อบรม',
      '170': '(บาท/คน)',
      '180': 'ชม.อบรม'
    },
    'HRESH6XC2': {
      '10': 'ประวัติการรับทุนของพนักงาน',
      '20': 'รหัส',
      '30': 'ชื่อทุน',
      '40': 'วันที่เริ่มต้น',
      '50': 'วันที่สิ้นสุด',
      '60': 'วันที่สิ้นสุด',
      '70': 'ภาระผูกพัน',
      '80': 'ระยะเวลา',
      '90': 'ที่ได้รับทุน',
      '100': 'ค่าใช้จ่าย'
    },
    'HRTR53C1': {
      '10': 'สำหรับปี',
      '20': 'ประจำเดือน',
      '30': 'รหัสโครงการ',
      '40': 'หรือ หลักสูตร',
      '50': 'รหัสหลักสูตร',
      '60': 'ชื่อหลักสูตร',
      '70': 'เดือน',
      '80': 'รุ่นที่',
      '90': 'วันที่เริ่ม',
      '100': 'วันที่สิ้นสุด',
      '110': 'วิทยากร/สถาบันจัดอบรม',
      '120': 'สถานที',
      '130': 'ทั้งหมด',
      '140': 'ตารางการฝึกอบรม',
      '150': 'ประเภท'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6ju.js